import script from "./DomainVerificationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainVerificationComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__